import React, { useState, useEffect } from 'react';
import styles from '../../Dor/Home/style.module.css';
import LoadingOverlay from '../../../Components/LoadingOverlay';
import { Button } from '../../../Components';
import HealthHeader from '../../../Components/HealthHeader';
import HealthCards from '../../../Components/HealthCard';
import { searchProducts } from '../../../services/kollectaHealthCore';
import { useNavigate } from 'react-router-dom';
import Modal from 'react-modal';
import SurgeryReportFilterTool from '../../../Components/ReportFilterTool/SurgeryReportFilterTool';
import ModalStatus from '../../../Components/ReportFilterTool/ModalStatus';

const Home = () => {
  const [loading, setLoading] = useState(true);
  const [patientCount, setPatientCount] = useState(0);
  const [modal, setModal] = useState(false);
  const [modalFeedback, setModalFeedback] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await searchProducts({
          customerName: '',
          personalNumber: '',
          studyNumber: '',
          type: 'cirurgias'
        });
        const count = response?.data?.count ?? response?.count ?? 0;
        setPatientCount(count);
      } catch (error) {
        console.error('Erro ao buscar dados de cirurgias:', error);
        setPatientCount(0);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const closeFiltersModal = () => {
    setModal(false);
  };

  const closeStatusModal = () => {
    setModal(false);
    setModalFeedback(false);
  };

  const data = [
    { value: patientCount, label: 'PACIENTES CADASTRADOS' },
    { value: '-', label: 'ÍNDICE DE ADESÃO AO ESTUDO' }
  ];

  return (
    <div className={styles.container}>
      <LoadingOverlay isLoading={loading} />
      <HealthHeader title="Dashboard de Pacientes - Cirurgias" />
      <div className={styles.content}>
        <div className={styles.buttonContainer} style={{ gap: '12px' }}>
          <Button onClick={() => navigate('/cirurgias/pesquisa')}>Ver Pacientes</Button>
          <Button onClick={() => setModal(true)}>Exportar Relatório</Button>
        </div>
        <HealthCards items={data} />
      </div>

      {!modalFeedback && (
        <Modal
          isOpen={modal}
          onRequestClose={closeFiltersModal}
          style={{
            overlay: {
              backgroundColor: 'rgba(0, 0, 0, 0.75)',
            },
            content: {
              top: '50%',
              left: '50%',
              right: 'auto',
              bottom: 'auto',
              marginRight: '-50%',
              transform: 'translate(-50%, -50%)',
              borderRadius: '8px',
              width: '615px',
            },
          }}
        >
          <div className={styles.modalContainer}>
            <SurgeryReportFilterTool closeModal={closeFiltersModal} setFeedback={setModalFeedback} />
          </div>
        </Modal>
      )}

      <ModalStatus type={modalFeedback} onClose={closeStatusModal} />
    </div>
  );
};

export default Home;
